import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#05050A] flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-2 border-white/20 border-t-[#FF2A85] rounded-full animate-spin mx-auto mb-4" />
          <p className="text-[#A1A1AA]">Caricamento...</p>
        </div>
      </div>
    );
  }

  if (!user || user === false) {
    return <Navigate to="/" replace />;
  }

  return children;
}
